import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b83da69a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b83da69a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83da69a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b83da69a')) {
      api.createRecord('b83da69a', component.options)
    } else {
      api.reload('b83da69a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b83da69a&scoped=true&", function () {
      api.rerender('b83da69a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BackIcon/index.vue"
export default component.exports